import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/css/paper-dashboard.css';
import './assets/css/custom-styles.css';

//Componente principal:
import App from './App';
import store from './storage/store';


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);

serviceWorker.unregister();